<script lang="ts" setup>
import { computed, ref } from "vue"
import CmsFaqPage from "./faq/CmsFaqPage.vue"
import CmsFaqSidebarGroup from "./faq/CmsFaqSidebarGroup.vue"
import CmsFaqSidebarPage from "./faq/CmsFaqSidebarPage.vue"
import { type FaqGroup, type FaqPage } from "./faq/FaqTypes"

const props = defineProps<{
    element: any
}>()

const firstElementOpenOnInit = true

const group = computed<FaqGroup>(() => props.element.group)
const page = computed<FaqPage>(() => props.element.page)

function getInitialOpenPage(): FaqPage | null {
    if (firstElementOpenOnInit) {
        if (group.value?.children?.[0]?.pages?.[0]) {
            return group.value.children[0].pages[0]
        }

        if (group.value?.pages?.[0]) {
            return group.value.pages[0]
        }
    }
    return null
}

const selectedPage = ref<FaqPage | null>(getInitialOpenPage())
</script>

<template>
    <div v-if="group">
        <div class="bg-primary text-white px-4 py-3" v-if="group.name">
            {{ group.name }}
        </div>
        <div class="row mt-3">
            <div class="col-md-3">
                <div class="accordion-enumeration-menu" v-if="group.children && group.children.length">
                    <CmsFaqSidebarGroup
                        v-for="(childGroup, index) in group.children"
                        :key="index"
                        :group="childGroup"
                        :selected-page="selectedPage"
                        :open="firstElementOpenOnInit && index === 0"
                        @page-selected="selectedPage = $event"
                    />
                </div>
                <div class="accordion-enumeration-menu" v-if="group.pages && group.pages.length">
                    <CmsFaqSidebarPage
                        :pages="group.pages"
                        :selected-page="selectedPage"
                        @page-selected="selectedPage = $event"
                    />
                </div>
            </div>
            <div class="col-md-9">
                <CmsFaqPage
                    :page="selectedPage"
                    :first-element-open-on-init="firstElementOpenOnInit"
                    v-if="selectedPage"
                />
            </div>
        </div>
    </div>

    <div v-if="page">
        <CmsFaqPage :page="page" />
    </div>
</template>
